const selectedFilterOptionsList = ({ selectedFilterOptions }) => {
  let list = []

  if (selectedFilterOptions?.fatigueLevels?.length > 0) {
    list.push(...selectedFilterOptions?.fatigueLevels)
  }

  if (selectedFilterOptions?.shifts?.length > 0) {
    list.push(...selectedFilterOptions?.shifts)
  }

  if (selectedFilterOptions?.levels?.length > 0) {
    list.push(...selectedFilterOptions?.levels)
  }

  if (selectedFilterOptions?.positions?.length > 0) {
    list.push(...selectedFilterOptions?.positions)
  }

  if (selectedFilterOptions?.teams?.length > 0) {
    list.push(...selectedFilterOptions?.teams)
  }

  if (selectedFilterOptions?.notificationsStatuses?.length > 0) {
    list.push(...selectedFilterOptions?.notificationsStatuses)
  }

  if (selectedFilterOptions?.counterMeasureStatuses?.length > 0) {
    list.push(...selectedFilterOptions?.counterMeasureStatuses)
  }

  if (selectedFilterOptions?.eventTypes?.length > 0) {
    list.push(...selectedFilterOptions?.eventTypes)
  }

  return list
}

const getMaxTagsToShow = ({ width }) => {
  if (width > 768) {
    const maxTextSize = 120

    const tagsToShow = Math.floor(width / maxTextSize)
    return tagsToShow - 3
  }

  return 2
}

const filterDrawerHelper = {
  getMaxTagsToShow,
  selectedFilterOptionsList,
}

export default filterDrawerHelper
